import React from 'react';
import {
    Col, FormGroup,
    Row
} from 'reactstrap';

import {LangController} from "../../../components/tabs/langController";
import {FL_LONG_DESCRIPTION, FL_TITLE} from "../../../components/i18n/formLabels";
import {PH_LONG_DESCRIPTION, PH_TITLE} from "../../../components/i18n/placeHolders";
import MarkdownInput from "../../../components/inputs/MarkdownInput";

const PlaceServicesLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },

            title: '',
            longDescription  : '',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={FL_TITLE}
                        placeholder={PH_TITLE}
                        type="text"
                        name="title"
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <MarkdownInput
                        label={FL_LONG_DESCRIPTION}
                        placeholder={PH_LONG_DESCRIPTION}
                        type="textarea"
                        name="longDescription"
                        rows={'10'}
                        onChange={onInputChange}
                        disabled={disableInputs}
                        child={child}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return <LangController
        markdown={true}
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default PlaceServicesLangs
